import React, { Component } from 'react';
import MaterialIcon from 'material-icons-react';
import admin from '../../../shared/images/admin.jpg';
import { connect } from 'react-redux';
import { logout } from '../../../auth/login/redux/actions';
import { getAuthentication } from '../../../auth/login/redux/selectors';
import './ProfileInfo.scss';
import { NavLink, withRouter } from 'react-router-dom';

class ProfileInfo extends Component {
    signout() {
        this.props.logout();
        // no need to redirect to login page, since you are allowed to stay on an authorised page only if you are logged in.
    }

    render() {
        return (
            <React.Fragment>
                {/* actions */}
                <div className={'profile-info-actions'}>
                    <div className={'menu-item'} onClick={() => this.signout()}>
                        <MaterialIcon color="inherit" icon="keyboard_return" />
                        <span className={'menu-item-text'}>Logout</span>
                    </div>
                    <NavLink className="menu-item" to="/help">
                        <MaterialIcon color="inherit" icon="help" />
                        <span className={'menu-item-text'}>Help</span>
                    </NavLink>
                </div>
                <div className="profile-info-container">
                    <div className={'admin-img'}>
                        <img alt={'Admin'} src={admin} />
                    </div>
                    <div className="profile-info">
                        <div className="profile-name">
                            {this.props.authentication.user.firstName}
                        </div>
                        <div className="profile-company">
                            {this.props.authentication.user.company}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const authentication = getAuthentication(state);

    return { authentication };
};

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(logout())
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ProfileInfo)
);
